export default __webpack_public_path__ + "83903cd3cbf3e3f57fdd44b829fb2e96.png";